import React, {Component} from 'react';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import MapLayer from "./MapLayerAndDateRange";
import '../styles/MapLayers.scss';

const grid = 4;
var pageLoad = true;
const getItemStyle = (isDragging: any, draggableStyle: any) => ({
    // some basic styles to make the items look a bit nicer
    userSelect: "none",
    padding: grid,
    // margin: `0 0 ${grid}px 0`,

    // change background colour if dragging
    background: isDragging ? "lightgrey" : null,
    borderRadius: "0.25rem",

    // styles we need to apply on draggables
    ...draggableStyle
});

const getListStyle = (isDraggingOver: any) => ({
  // background: isDraggingOver ? "grey" : null,
  width: "100%"
});

export default class MapLayers extends Component<any, any> {
    constructor(props: any) {
        super(props);
        console.log("MapLayers > props ", props);
        this.state = {
        }

    }

    emitLayerListOrderChange(draggedTitle: string, droppedTitle: string) {
        console.log("draggedTitle, droppedTitle,", draggedTitle, droppedTitle)
        const layerOrder = this.props.layers.map((l: any) => l.get('title'));
        console.log("layerOrder", layerOrder)
        const forLayerListOnLoad = [];

        const draggedIndex = layerOrder.indexOf(draggedTitle);
        if (draggedIndex === -1) {
            throw new Error(`could not find ${draggedTitle} in layers list`);
        }

        const droppedIndex = layerOrder.indexOf(droppedTitle);
        if (droppedIndex === -1) {
            throw new Error(`could not find ${droppedTitle} in layers list`);
        }

        // remove the dragged layer title from array
        layerOrder.splice(draggedIndex, 1);

        // re-insert the dragged layer title at the index where it was dropped
        layerOrder.splice(droppedIndex, 0, draggedTitle);
        for (const storedLayerObj of layerOrder) {
            for (const realLayerObj of this.props.layers) {
                if (realLayerObj.values_.title === storedLayerObj){
                    realLayerObj["title"] = realLayerObj.values_.title;
                    forLayerListOnLoad.push(realLayerObj);
                } 
            }
        }
        console.log("handleLayerOrderChange layerOrder", layerOrder)
        console.log("handleLayerOrderChange forLayerListOnLoad", forLayerListOnLoad)
        console.log("this.map.layerListOnLoad", this.props.map_.layerListOnLoad )
        this.props.map_.layerListOnLoad = forLayerListOnLoad;
        console.log("this.map.layerListOnLoad", this.props.map_.layerListOnLoad )
        //this.props.map_.layerList= forLayerListOnLoad;
        this.props.map_.originalLayerOrder = forLayerListOnLoad;
        console.log("layerOrder", layerOrder)
        this.props.handleLayerOrderChange(layerOrder, true);
    }

    onDragEnd(result: any) {
        console.log('onDragEnd', result);
        console.log('this.props.layers', this.props.layers);

        // dropped outside the list
        if (!result.destination) {
            return;
        }

        const draggedTitle = this.props.layers[result.source.index].get('title');
        const droppedTitle = this.props.layers[result.destination.index].get('title');
        this.emitLayerListOrderChange(draggedTitle, droppedTitle);
    }

    // following "simple vertical list" example
    // https://github.com/atlassian/react-beautiful-dnd/blob/master/docs/about/examples.md
    // https://codesandbox.io/s/k260nyxq9v
    render() {
        /*
        console.log("MapLayerAndDateRange > this.props.layers,", this.props.layers);
        console.log("MapLayerAndDateRange > this.props,", this.props);
        console.log("MapLayerAndDateRange > this.props.map_,", this.props.map_);
        
        if(this.props.map_){
            if(this.props.map_.originalLayerOrder){
                console.log("originalLayerOrder")
                for (const mL of this.props.map_.originalLayerOrder) {
                    console.log("originalLayerOrder > ", mL.title);
                }  
            }             
            if(this.props.map_.layerList){
                console.log("layerList")
                for (const mLX of this.props.map_.layerList) {
                    console.log("layerList > ", mLX.title);
                }  
            } 
            console.log("layerListOnLoad");     
            if(this.props.map_.layerListOnLoad){
                for (const mL2 of this.props.map_.layerListOnLoad) {
                    console.log("layerListOnLoad > ", mL2.title);
                }
            }
        }
        */
        // Check if all layers have been returned from DW API and added to map. If so, make sure that layer order is correct. 
        //
        //console.log("this.props.map_", this.props.map_)
        if (this.props.map_){
            /*
            console.log("MapLayerAndDateRange > this.props.map_.layerList,", this.props.map_.layerList)
            console.log("MapLayerAndDateRange > this.props.layers,", this.props.layers)
            console.log("MapLayerAndDateRange > this.props.map_.layerList.length,", this.props.map_.layerList.length)
            console.log("MapLayerAndDateRange > this.props.layers.length,", this.props.layers.length)*/
            
            //console.log("Layer-DEV pageLoad", pageLoad)
            if (pageLoad){
                //console.log("Layer-DEV this.props.map_.layerListOnLoad", this.props.map_.layerListOnLoad)
                //console.log("Layer-DEV this.props.layers", this.props.layers)
                //console.log("this.props.map_.layerListOnLoad.length", this.props.map_.layerListOnLoad.length)
                //console.log("this.props.layers.length", this.props.layers.length)
                if (this.props.map_.layerListOnLoad.length === this.props.layers.length){
                    //console.log("Layer-DEV Layers added, check order")
                    //console.log("Layer-DEV this.props.map_", this.props.map_)
                    //console.log("Layer-DEV this.props.map_.layerListOnLoad", this.props.map_.layerListOnLoad)
                    var loadedLayerOrder = []
                    for (const mLayer of this.props.map_.layerListOnLoad) {
                        //console.log("Layer-DEV Layer.title,", mLayer.title);
                        //console.log("Layer-DEV  ... AND HERE");
                        loadedLayerOrder.push(mLayer.title)
                    }   
                    //console.log("Layer-DEV loadedLayerOrder", loadedLayerOrder)            
                    pageLoad = false;

                    this.props.handleLayerOrderChange(loadedLayerOrder, false);  
                }else{
                    //console.log("Layer-DEV  ... BETWEEN HERE");
                    pageLoad = true;
                }
                //pageLoad = false;
            }
        }
        /*var thisPropsLayers = this.props.layers
        console.log("this.props.layers",this.props.layers)
        if (this.props.map_){
            if (this.props.map_.layerListOnLoad){
                console.log("this.props.map_.layerListOnLoad",this.props.map_.layerListOnLoad)
                thisPropsLayers = [];
                for (const storedLayerObj of this.props.map_.layerListOnLoad) {
                    for (const realLayerObj of this.props.layers) {
                        if (realLayerObj.values_.title === storedLayerObj.title) 
                        thisPropsLayers.push(realLayerObj);
                    }
                }
            }else{console.log("NO this.props.map_.layerListOnLoad")}
        }else{console.log("NO this.props.map_")}*/
        
        
        return (
            <div id="syncarto-map-layers-container">
              <DragDropContext onDragEnd={(a: any) => this.onDragEnd(a)}>
                <Droppable droppableId="droppable">
                  {(provided: any, snapshot: any) => (
                      <div
                      {...provided.droppableProps}
                      ref={provided.innerRef}
                      style={getListStyle(snapshot.isDraggingOver)}
                      >
                        {this.props.layers.map((layer: any, i: number) => (
                            <Draggable draggableId={layer.get('title')} key={layer.get('title')} index={i}>
                              {(provided: any, snapshot: any) => (
                                  <div
                                  ref={provided.innerRef}
                                  {...provided.draggableProps}
                                  style={getItemStyle(
                                      snapshot.isDragging,
                                      provided.draggableProps.style
                                  )}
                                  >
                                  <MapLayer
                                    layer={layer}
                                    dragHandleProps={provided.dragHandleProps}
                                    emitLayerList={(cmd: any, newLayer: any, deletedLayer: any, styledLayer: any, caller: any) => this.props.emitLayerList(cmd, newLayer, deletedLayer, styledLayer, caller)} 
                                    dwDefinition={this.props.dwDefinition}
                                    configUpdated={(queryConfig: any, _layer:any) => this.props.configUpdated(queryConfig, _layer)}
                                    layerStyleUpdated={(highColor: any, lowColor: any, highPoint: any, lowPoint: any, _layer: any, max:any, min:any) => this.props.layerStyleUpdated(highColor, lowColor, highPoint, lowPoint, _layer, max, min)}
                                    updateDwLayers={() => this.props.updateDwLayers()}
                                    definitionWrappers={this.props.definitionWrappers}
                                    />
                                </div>
                              )}
                            </Draggable>
                        ))}
                        {provided.placeholder}
                      </div>
                  )}
                </Droppable>
              </DragDropContext>
            </div>
        );
    }
}
